export class AppConfig {
  /**
   * .envのREACT_APP_MODEに設定されているUI起動モード
   */
  static readonly MODE = process.env.REACT_APP_MODE;
  /**
   * オフラインモード
   */
  static readonly MODE_OFFLINE = "offline";
  /**
   * クラウドモード
   */
  static readonly MODE_CLOUD = "cloud";

  /**
   * 利用規約有無
   */
  static readonly LINK_TERMS_ENABLED =
    typeof process.env.REACT_APP_TERMS_ENABLED !== "undefined" &&
    process.env.REACT_APP_TERMS_ENABLED === "true"
      ? true
      : false;

  /**
   * 障害報告有無
   */
  static readonly LINK_INCIDENTS_ENABLED =
    typeof process.env.REACT_APP_INCIDENTS_ENABLED !== "undefined" &&
    process.env.REACT_APP_INCIDENTS_ENABLED === "true"
      ? true
      : false;

  /**
   * ファイルアップロード対象拡張子
   */
  static readonly UPLOAD_FILES_EXTENSION =
    ".TSV";

  /**
   * 設定ファイルアップロード対象拡張子
   */
  static readonly UPLOAD_SFILES_EXTENSION =
  ".JSON";

  /**
   * 最大アップロードファイルサイズ
   */
  static readonly MAX_UPLOAD_FILE_SIZE = 1024 * 1024 * 25;

  /**
   * 通知確認間隔(msec)
   */
  static readonly NOTICES_INTERVAL = 5000;
  /**
   * 非操作タイムアウト(msec)
   */
  static readonly UNOPERATED_TIMEOUT = 30 * 60 * 1000;
  /**
   * プロジェクト情報更新間隔(msec)
   */
  static readonly PROGRESS_INTERVAL = 1 * 60 * 1000;
  /**
   * 最大プロジェクト数
   */
  static readonly MAX_PROJECTS = 5;
  /**
   * 最大ファイル数
   */
  static readonly MAX_FILES = 10;
  /**
   * 最大シミュレータ数
   */
  static readonly MAX_SIMULATORS = 10;
  /**
   * 最大シミュレータシミュレーション数
   */
  static readonly MAX_SIM_SIMULATION = 5;
  /**
   * 設定ファイル数
   */
  static readonly MAX_SETTING_FILE = 1;
  /**
   * Cookie同意Cookie名
   */
  static readonly COOKIE_CONSENT_COOKIE_NAME = "AIBatchCookieConsent";
}

export class Locale {
  /**
   * 表示言語初期値
   * ブラウザの設定を使用する
   */
  static readonly DEFAULT = navigator.language;
  /**
   * 表示言語が存在しない場合の言語
   */
  static readonly NOTEXIST = "en";
  /**
   * 表示言語定義
   * ja : Japanese
   * en : English
   */
  static readonly LOCALES = [
    { label: "Japanese", lang: "ja" },
    { label: "English", lang: "en" },
  ];
}

export class MainSpace {
  static readonly PROJECTS: number = 0;
  static readonly NOTICE: number = 1;
  static readonly LISENCE: number = 2;
  static readonly HELP: number = 3;
}

export class Projects {
  static readonly PROJECT_LIST: number = 0;
  static readonly PROJECT_DETAIL: number = 1;
}

export class ProjectDetail {
  static readonly FILES: number = 0;  
  static readonly CREATE_SIMULATOR: number = 1; 
  static readonly LIST_SIMULATOR: number = 2; 
  static readonly RESULT_SIMULATION_SIMULATOR: number = 3;
  static readonly SETTINGS_FKDPPMODEL: number = 4;
  static readonly EVALUATE_MODEL: number = 5;
  static readonly SIMULATE_MODEL: number = 6;
}

export class Files {
  static readonly FILE_LIST: number = 0;
  static readonly CHART_LIST: number = 1;
}

export class ProjectStatus {
  static readonly NONE = "none";
  static readonly DOING = "doing";
  static readonly DONE = "done";
}

export class SettingType {
  /**
   * 学習条件自動モード
   */
  static readonly AUTO = "Auto";
  /**
   * 学習条件詳細設定モード
   */
  static readonly CUSTOM = "Custom";
}

export class ControlMode {
  /**
   * 制御モード直接制御
   */
  static readonly DIRECT = "Direct";
  /**
   * 制御モード間接制御
   */
  static readonly INDIRECT = "Indirect";
}

export class ConfigurationFileType {
  /**
   * シミュレータ作成設定ファイル
   */
  static readonly SIMULATOR_CONF = "siconf";
  /**
   * モデル学習fkdppconf
   */
  static readonly TRAIN_FKDPPCONF = "fkdppconf";
  /**
   * モデル学習simconf
   */
  static readonly TRAIN_SIMCONF = "simconf";
  /**
   * モデル学習rewardconf
   */
  static readonly TRAIN_REWARDCONF = "rewardconf";
  /**
   * 学習モデル評価設定ファイル
   */
  static readonly VALIDATION_CONF = "evalconf";
}

export class ChartList {
  /**
   * チャートテーブルLeft Margin
   */
  static readonly TABLE_MARGIN_LEFT = 0;
  /**
   * 表示対象最大データ数(モデル作成、プロファイル作成、モデルテスト)
   */
  static readonly MAX_DATA_NUM = 30000;

  /**
   * ファイルチャート幅
   */
  static readonly FILES_WIDTH = 320;
  /**
   * ファイルチャート高さ
   */
  //static readonly FILES_HEIGHT = 240;
  static readonly FILES_HEIGHT = 120;

  /**
   * シミュレータシミュレーション一覧チャート幅
   */
  static readonly SIM_WIDTH = 400;
  /**
   * シミュレータシミュレーション一覧チャート高さ
   */
  static readonly SIM_HEIGHT = 150;

  /**
   * 凡例表示有無
   */
  static readonly LEGEND_SHOW = true;
  /**
   * 凡例表示位置
   * "bottom" | "right" | "inset"
   */
  static readonly LEGEND_POSITION = "inset";
  /**
   * inset時の表示位置
   * "top-left" | "top-right" | "bottom-left" | "bottom-right"
   */
  static readonly LEGEND_ANCHOR = "top-right";

  /**
   * ツールチップ表示有無
   */
  static readonly TOOLTIP_SHOW = false;
  /**
   * ツールチップグループ化有無
   * falseの場合、重なっているデータは先頭のみ表示
   */
  static readonly TOOLTIP_GROUPED = false;

  /**
   * X軸単位表示位置
   * "inner | outer - right | center | left"
   */
  static readonly LABEL_POSITION = "outer-right";
  /**
   * X軸単位
   */
  static readonly LABEL_TEXT_X = "[sec]";

  /**
   * グラフ一覧表示グリッド線表示有無
   */
  static readonly GRID_CHARTLIST = false;
  
  /**
   * チャート一覧間引き閾値
   */
  static readonly CHART_LIST_THRESHOLD = 50;

  /**
   * リサイズ有無
   */
  static readonly RESIZE_ENABLED = false;

  /**
   * InputデータID
   */
  static readonly ID_INPUT = "chart_file_inrows_";
  /**
   * OutputデータID
   */
  static readonly ID_OUTPUT = "chart_file_outrows_"; 
}

export class ChartDialogConfig {
  /**
   * チャートダイアログ範囲補正
   */
  static readonly CHAERT_DIALOG_AREA_CORRECTION = 4 / 5;

  /**
   * 一回あたりのX軸拡大率
   */
  static readonly CHART_X_AXIS_SCALE_RATE = 0.25;

  /**
   * 一回あたりのY軸拡大率
   */
  static readonly CHART_Y_AXIS_SCALE_RATE = 0.25;

  /**
   * トリミングチャート間引き閾値
   */
  static readonly TRIMMING_CHART_THRESHOLD = 300;

  /**
   * シミュレーション結果間引き閾値
   */
  static readonly RESULT_CHART_THRESHOLD = 100;

  /**
   * 拡大ダイアロググリッド線表示有無
   */
  static readonly GRID_CHARTDIALOG = true;

  /**
   * Y軸範囲補正
   */
  static readonly CHART_Y_AXIS_RANGE_CORRECTION = 0.5;

  /**
   * Y軸の最大最小値が0の場合、最大最小値に設定します
   */
  static readonly CHART_Y_AXIS_ZERO_VALUE = 50;

  /**
   * 最大Y軸設定値
   */
  static readonly MAX_Y_AXIS_VALUE = Number.MAX_SAFE_INTEGER;

  /**
   * 最小Y軸設定値
   */
  static readonly MIN_Y_AXIS_VALUE = Number.MIN_SAFE_INTEGER;
}

export class ListConfig {
  /**
   * ドロップダウンリストの最大高さ
   */
  static readonly MENU_PROPS = {
    PaperProps: {
      style: {
        maxHeight: 300,
      },
    },
  };
}

/**
 * any型
 */
// eslint-disable-next-line
export type AnyType = any;

/**
 * DataGridの選択行
 */
export type DataGridCheckRow = AnyType;
